import { OrderStatusEnum } from "../enums/orderStatus";

export const convertOrderStatusCodeToOrderStatusEnum = (
  value: number
): string => {
  switch (value) {
    case 1:
      return OrderStatusEnum.CURRENT_ORDER;
    case 3:
      return OrderStatusEnum.To_Pack;
    case 4:
      return OrderStatusEnum.To_Ship;
    case 5:
      return OrderStatusEnum.Shipping;
    case 6:
      return OrderStatusEnum.Delivered;
    case 7:
      return OrderStatusEnum.Failed;
    case 8:
      return OrderStatusEnum.Return;

    default:
      return "";
  }
};

export const convertOrderStatusEnumToStatusCode = (
  value: OrderStatusEnum
): number => {
  switch (value) {
    case OrderStatusEnum.CURRENT_ORDER:
      return 1;
    case OrderStatusEnum.To_Pack:
      return 3;
    case OrderStatusEnum.To_Ship:
      return 4;
    case OrderStatusEnum.Shipping:
      return 5;
    case OrderStatusEnum.Delivered:
      return 6;
    case OrderStatusEnum.Failed:
      return 7;
    case OrderStatusEnum.Return:
      return 8;

    default:
      return null!;
  }
};

const convertOrderStatusCodeToMessage = (value: number): string => {
  switch (value) {
    case 1:
      // la = 'ມີລາຍການສັ່ງຊື້ໃໝ່';
      return "Checked out or New order";
    case 2:
      // la = 'ລໍຖ້າການຊຳລະເງີນຈາກ Onepay';
      return "Waiting for payment from Onepay";
    case 3:
      // la = 'ລາຍການຂອງທ່ານຖືກຍອມຮັບຈາກພະນັກງານແລ້ວ';
      return "rider the accepted";
    case 4:
      // la = 'ລາຍການຂອງທ່ານພອ້ມແລ້ວ';
      return "Your order is ready to pickup";
    case 5:
      // la = 'ຍົກເລີກການສັ່ງຊື້';
      return "Order Cancelled";
    case 6:
      // la = 'ສິ້ນຄ້າຖືກຕີກັບ';
      return "Return Order";
    case 7:
      // la = 'ລາຍການຂອງທ່ານກຳລັງຖິກຈັດສົ່ງ';
      return "Your order is ready to pickup";
    case 8:
      // la = 'ລາຍການສັ່ງຊື້ສຳເລັດແລ້ວ';
      return "Completed Order";
    default:
      // la = 'ອໍເດີຖືກສ້າງສຳເລັດ';
      return "Order was created";
  }
};
